import {Component, EventEmitter, Input, NgZone, Output} from '@angular/core';
import {FieldItem} from "../../models/FieldItem";
import {VizixService} from "../../providers/vizix.service";
import {
  TAG_INFORMATION_SOURCE_CYCLE_COUNT,
  TAG_INFORMATION_SOURCE_FIND_ITEM,
  TAG_INFORMATION_SOURCE_IDENTIFY_TAG, TAG_INFORMATION_SOURCE_LOOK_UP, TAG_INFORMATION_SOURCE_POPOVER,
  TAG_INFORMATION_SOURCE_REPLENISHMENT,
  TagType
} from "../../app/app.constants";
import {TranslateService} from "@ngx-translate/core";
import {TagInformationService} from "../../providers/tag.information.service";
import {Subscription} from "rxjs/Subscription";
import {Platform} from "ionic-angular";

@Component({
  selector: 'tag-information',
  templateUrl: 'tag-information.html'
})
export class TagInformationComponent {

  @Input('visible') visible: boolean = true;
  @Input('source') source: string = TAG_INFORMATION_SOURCE_POPOVER;
  @Output() onFinished: EventEmitter<any> = new EventEmitter();
  @Output() onFieldValueFound: EventEmitter<any> = new EventEmitter();
  @Output() onNoInformationFound: EventEmitter<any> = new EventEmitter();
  @Output() onError: EventEmitter<any> = new EventEmitter();
  @Output() onStartLoading: EventEmitter<any> = new EventEmitter();
  @Output() onFinishLoading: EventEmitter<any> = new EventEmitter();

  public tag: string;
  public isLoading: boolean = false;
  public fieldItems: Array<FieldItem> = [];
  public imageURL: string = '';
  public isImageZoom = false;
  private tagSubscription: Subscription;
  private identifyTagSubscription: Subscription;
  private sohReportSubscription: Subscription;

  private fieldLabelToSearchSOH;
  private fieldLabelToSearch;

  public isImageUrlNotError=true;

  private isIosVersionLessThan11: boolean = false;

  constructor(private vizixService: VizixService,
              public translate: TranslateService,
              public ngZone: NgZone,
              public platform: Platform,
              public tagInformationService: TagInformationService) {

    this.fieldLabelToSearchSOH = this.vizixService.configurationApp.IdentifyItemConfiguration.FieldValueSOH.value;
    this.tagSubscription = this.tagInformationService.getTag().subscribe((inputValues) => {
      if (inputValues.source === this.source) {
        // First clear any other subscription
        if (this.identifyTagSubscription) {
          this.identifyTagSubscription.unsubscribe();
        }
        if (this.sohReportSubscription) {
          this.sohReportSubscription.unsubscribe();
        }
        // Clear fields
        this.imageURL = '';
        this.fieldItems = [];
        this.tag = inputValues.tag;
        this.fieldLabelToSearch = inputValues.fieldValueToSearch ||
          this.vizixService.configurationApp.IdentifyItemConfiguration.FieldValueSOH.value;
        if (inputValues.tag) {
          // Modules that can receive multiple consecutive readings wont remove observer
          switch (inputValues.source){
            case TAG_INFORMATION_SOURCE_IDENTIFY_TAG: {
              this.lookupTag(inputValues.tag, false);
              break;
            }
            case TAG_INFORMATION_SOURCE_LOOK_UP: {
              this.lookupTag(inputValues.tag, false);
              break;
            }
            case TAG_INFORMATION_SOURCE_FIND_ITEM: {
              this.lookupTag(inputValues.tag, false);
              break;
            }
            case TAG_INFORMATION_SOURCE_POPOVER: {
              this.lookupTag(inputValues.tag, true);
              break;
            }
            case TAG_INFORMATION_SOURCE_CYCLE_COUNT: {
              this.lookupTag(inputValues.tag, true);
              break;
            }
            case TAG_INFORMATION_SOURCE_REPLENISHMENT: {
              this.lookupTag(inputValues.tag, true);
              break;
            }
            default: {
              this.lookupTag(inputValues.tag, true);
            }
          }
        }
      }
    });
    this.askPlatformOs();
  }


  //Ask OS and Ios version
  askPlatformOs() {
    this.platform.ready().then(() => {
      if (this.platform.is('android')) {
        this.isIosVersionLessThan11 = false;
      } else if (this.platform.is('ios')) {
        const osVersionNumber = this.platform.version().num;
        this.isIosVersionLessThan11 = osVersionNumber < 11;
      } else if (this.platform.is('mobileweb')) {
        this.isIosVersionLessThan11 = false;
      } else {
        this.isIosVersionLessThan11 = false;
      }
    });
  }

  ngOnDestroy() {
    if (this.tagSubscription)
      this.tagSubscription.unsubscribe();
    if (this.identifyTagSubscription)
      this.identifyTagSubscription.unsubscribe();
  }

  removeSubscribers() {
    if (this.tagSubscription)
      this.tagSubscription.unsubscribe();
    if (this.identifyTagSubscription)
      this.identifyTagSubscription.unsubscribe();
  }



  /**
   * Returns the TagType of an input string tag
   * @param {string} tag
   * @returns {TagType}
   */
  validateAndSearch(tag: string): TagType {
    tag = tag.toUpperCase().trim();
    if (tag && tag.length) {
      if (this.vizixService.validateUpc(tag)) {
        console.log(this.tag, 'UPC');
        return TagType.UPC;
      } else if (this.vizixService.validateSku(tag)) {
        console.log(this.tag, 'SKU');
        return TagType.SKU;
      } else if (this.vizixService.validateRfid(tag)) {
        console.log(this.tag, 'RFID');
        return TagType.EPC;
      } else {
        return TagType.UNKNOWN;
      }
    }
  }

  lookupTag(tag: string, needRemoveObserver: boolean) {
    //Make a Vizix call
    this.ngZone.run(() => {
      this.isLoading = true;
      this.onStartLoading.emit();
    });
    this.identifyTagSubscription = this.vizixService.VizixPostReportExecutionFindItemIdentify(this.validateAndSearch(tag), tag).subscribe((data: any) => {
      this.isLoading = false;
      this.onFinishLoading.emit();
      if (data.response.results.length > 0) {
        this.fieldItems = this.formatDataTypeOrderInformation(data.tagType, data.response.results[0]);

        // Look for ImageURL and format it depending if it is base64 or URL
        let imageUrl = '';
        const findImage = this.fieldItems.find((row) => row.label === 'ImageURL');
        if (findImage) {
          if (findImage.value) {
            imageUrl = findImage.value.indexOf('://') === -1 ? 'data:image/jpeg;base64,' + findImage.value : findImage.value;
          }
        }
        this.fieldItems.map((fieldItem) => {
          if (fieldItem.label == 'ImageURL') {
            fieldItem.value = imageUrl;
          }
          return fieldItem;
        });
        this.ngZone.run(() => {
          this.imageURL = TagInformationComponent.getValue(this.fieldItems);
          this.fieldItems = this.fieldItems.filter((fieldItem) => {
            return fieldItem.label != 'ImageURL';
          });
        });
        this.onFinished.emit();

        // Now get the item's SOH
        this.getSOH(this.validateAndSearch(tag))
      } else {
        // no information found
        this.onNoInformationFound.emit();
        this.isLoading = false;
        this.onFinishLoading.emit();
        console.log(this.tag, "No information found");
      }
      if (needRemoveObserver)
        this.removeSubscribers();
    }, (error) => {
      // an error ocurred in the request
      this.isLoading = false;
      this.onFinishLoading.emit();
      this.onError.emit(error);
      console.log(this.tag, "Server error", error);
      if (needRemoveObserver)
        this.removeSubscribers();
    });
  }

  formatDataTypeOrderInformation(tagType: TagType, informationMap: Map<string, any>): FieldItem[] {
    console.log(this.tag, 'Information to order', informationMap);

    let response: FieldItem[] = [];
    let orderedResponse: FieldItem[] = [];
    for (let label in informationMap) {
      let value: any = informationMap[label];
      // Here we filter the default fields returned by the report TODO: Make the Product Status parametric
      if (label != 'ProductStatus' && label != 'thingTypeId' && label != 'thing.headers' && label != 'id') {
        response.push(new FieldItem(label, this.formatDataType(label, value, tagType)));
      }
    }

    // Now order using the report definition
    let reportPropertyList: any[];

    if (tagType == TagType.UPC || tagType == TagType.SKU) {
      reportPropertyList = this.vizixService.identifyProductReportDefinition.getReportProperty();
    } else if (tagType == TagType.EPC) {
      reportPropertyList = this.vizixService.identifyTagReportDefinition.getReportProperty();
    } else if (tagType == TagType.UNKNOWN) {
      reportPropertyList = [];
    }

    // We assume the list is already ordered in the response
    for (let reportProperty of reportPropertyList) {

      // Iterate our response to get the value
      for (let informationField of response) {

        if (informationField['label'] == reportProperty['label']) {

          orderedResponse.push(informationField);
          break;
        }
      }
    }
    return orderedResponse;
  }

  formatDataType(label: string, value: any, tagType: TagType): string {
    // We check for the udf using the label and convert dataType.name values from udf to label

    let reportPropertyArray = [];
    let dataTypes = [];

    if (tagType == TagType.UPC || tagType == TagType.SKU) {
      reportPropertyArray = this.vizixService.identifyProductReportDefinition.getReportProperty();
      dataTypes = this.vizixService.productsDataTypes;
    } else if (tagType == TagType.EPC) {
      reportPropertyArray = this.vizixService.identifyTagReportDefinition.getReportProperty();
      dataTypes = this.vizixService.itemDataTypes;
    }

    for (let property of reportPropertyArray) {
      if (property.label == label) {
        for (let dataType of dataTypes) {
          if (dataType.name == property.propertyName) {
            dataType.name = property.label;
          }
        }
      }
    }
    return this.vizixService.formatDataType(label, value, dataTypes);
  }

  getToSearchValueSecondReport(fieldLabel): string {
    // First we get the value to search in the SOH report
    for (let informationField of this.fieldItems) {
      if (informationField.label == fieldLabel) {
        return informationField.value;
      }
    }
  }

  getSOH(tagType: TagType) {

    let toSearchValue: string = this.getToSearchValueSecondReport(this.fieldLabelToSearchSOH);

    if (toSearchValue) {
      console.log(this.tag, 'Executing SOH Report for ' + this.vizixService.configurationApp.IdentifyItemConfiguration.FieldValueSOH.value, toSearchValue);
      let filtersJson = {};
      filtersJson[this.vizixService.configurationApp.IdentifyItemConfiguration.FilterLabelSOHSerial.value] = String(toSearchValue);
      filtersJson[this.vizixService.configurationApp.IdentifyItemConfiguration.FilterLabelSOHStoreID.value] = String(this.vizixService.getStoreId());
      console.log(this.tag, 'Filters JSON:', filtersJson);

      this.sohReportSubscription = this.vizixService.VizixPostReportExecutionSOH(filtersJson).subscribe(
        (data: { label: string, qty: number }) => {
          this.ngZone.run(() => {
            this.fieldItems.push(new FieldItem(data.label, this.formatDataType(data.label, data.qty, tagType)));
          });
        },
        err => {
          this.isLoading = false;
          this.onFinishLoading.emit();
          console.log(this.tag, 'error', err);
          // this.alertServerError.present();
        },
        () => {
          this.isLoading = false;
          this.onFinishLoading.emit();
        }
      );
    } else {
      // this.alertReportError.present();
      this.isLoading = false;
      this.onFinishLoading.emit();
    }

    this.onFieldValueFound.emit(this.getToSearchValueSecondReport(this.fieldLabelToSearch));
  }

  static getValue(fieldItemArray: Array<FieldItem>): string {
    let findImage = fieldItemArray.find((row) => row.label === 'ImageURL');
    if (findImage) {
      if (findImage.value) {
        return findImage.value;
      }
    }
    return '';
  }

  toggleImage() {
    if(this.isImageUrlNotError){
      this.isImageZoom = !this.isImageZoom;
    }
  }
  makeImageNoClickable() {
    this.isImageUrlNotError=false;
    this.imageURL = "assets/img/noImageError.jpg";
  }
}



// WEBPACK FOOTER //
// ./src/components/tag-information/tag-information.ts